const Time = {
  iso (value) {
    if (typeof value !== 'number') return value

    let iso = new Date(value * 1000).toISOString()
    let start = 11
    let end = 8

    if (iso.substr(start, 2) === '00') {
      start = 14
      end = 5
    }

    return iso.substr(start, end)
  },
  url (value) {
    let time = typeof value === 'number' ? Time.iso(value).split(':') : value.split(':')

    if (time.length === 3) {
      return `${parseInt(time[0])}h${parseInt(time[1])}m${parseInt(time[2])}s`
    } else if (time.length === 2) {
      return `${parseInt(time[0])}m${parseInt(time[1])}s`
    }

    if (time[0] >= 60) {
      return Time.url(parseInt(time[0]))
    }

    return `${time[0]}s`
  }
}

module.exports = Time
